<app-modal
  [title]="'Auszahlen mit...' | trans:'cart/payment-method-picker-modal/header/title'"
  maxWidth="1200px"
  minWidth="{{ showVoucherOutOption ? '40%' : '30%' }}"
  width="fit-content"
  [compact]="true"
>
  <ng-template>
    <div class="d-flex gap-8">
      <ng-template
        [ngTemplateOutlet]="paymentButtonTemplate"
        [ngTemplateOutletContext]="{ type: cartPaymentMethods.Cash, icon: 'ri-coin-line', disabled: isTerminalWithoutSafe }"
      />

      @if (showVoucherOutOption) {
        <ng-template
          [ngTemplateOutlet]="paymentButtonTemplate"
          [ngTemplateOutletContext]="{ type: cartPaymentMethods.VoucherOut, icon: 'ri-gift-line' }"
        />
      }

      <ng-template
        [ngTemplateOutlet]="paymentButtonTemplate"
        [ngTemplateOutletContext]="{ type: cartPaymentMethods.CustomerCard, icon: 'ri-bank-card-line' }"
      />

      <ng-template
        [ngTemplateOutlet]="paymentButtonTemplate"
        [ngTemplateOutletContext]="{ type: cartPaymentMethods.Card, icon: 'ri-bank-card-2-line', disabled: (!terminalParametersMap()[terminalParameterKeys.CASH_EC_TERMINAL_IP] && !isEcStandalone && !isEcSumUp) || isSumUpCardBlocked }"
      />

      <ng-template
        [ngTemplateOutlet]="paymentButtonTemplate"
        [ngTemplateOutletContext]="{ type: cartPaymentMethods.Invoice, icon: 'ri-bill-line' }"
      />
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ 'Cancel'| trans:'cart/payment-method-picker-modal/cancel.Button' }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        [disabled]="!selectedPaymentMethod || isPaymentMethodDisabledMap()[selectedPaymentMethod]"
        (click)="confirmSelectedPaymentMethod()"
      >
        {{ 'Confirm'| trans:'cart/payment-method-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<ng-template #paymentButtonTemplate let-type="type" let-icon="icon" let-disabled="disabled">
  <app-payment-button
    class="payment-button"
    [disabled]="disabled || isPaymentMethodDisabledMap()[type]"
    [type]="type"
    [icon]="icon"
    (paymentClick)="selectedPaymentMethod = $event"
    [theme]="selectedPaymentMethod === type ? 'green' : 'blue'"
  />
</ng-template>
